import {
  Configuration,
  LogLevel,
  ProtocolMode,
  PublicClientApplication,
} from '@azure/msal-browser';
import { msalPlugin } from './scripts/MsalPlugin';
import { useConfiguration } from '@/composables/useConfigration';

export default defineNuxtPlugin(async (nuxtApp) => {
  const configuration = useConfiguration();

  const msalConfig: Configuration = {
    auth: {
      authority: configuration.OPEN_ID_BASE_URL,
      knownAuthorities: [new URL(configuration.OPEN_ID_BASE_URL).host],
      protocolMode: ProtocolMode.OIDC,
      clientId: configuration.AUTH.strategies.oidc.clientId,
      redirectUri: configuration.AUTH.redirect.callback,
      navigateToLoginRequestUrl: false,
      postLogoutRedirectUri: configuration.AUTH.redirect.postLogout
    },
    cache: {
      cacheLocation: "sessionStorage",
      storeAuthStateInCookie: true,
    },
    system: {
      loggerOptions: {
        loggerCallback: (level: LogLevel, message: string, containsPii: boolean) => {
          if (containsPii) {
            return;
          }
          switch (level) {
            case LogLevel.Error:
              console.error(message);
              return;
            case LogLevel.Info:
              console.info(message);
              return;
            case LogLevel.Verbose:
              console.debug(message);
              return;
            case LogLevel.Warning:
              console.warn(message);
              return;
            default:
              return;
          }
        },
        logLevel: LogLevel.Verbose,
      },
    },
  };

  const msalInstance = new PublicClientApplication(msalConfig);

  nuxtApp.vueApp.use(msalPlugin, msalInstance);
});
